<script setup lang="ts">
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VDialog from '@components/dialogs/VDialog/VDialog.vue';

import type { IAffiliateBannerDialogEmits, IAffiliateBannerDialogProps } from './types';

defineProps<IAffiliateBannerDialogProps>();
defineEmits<IAffiliateBannerDialogEmits>();

const visible = defineModel<boolean>('visible');

function close() {
  visible.value = false;
}
</script>

<template>
  <VDialog
    v-model:visible="visible"
    :close-on-escape="closeOnEscape"
    :dismissable-mask="dismissableMask"
    class="rounded-2xl"
    no-min-size
    @hide="$emit('hide')"
  >
    <template #container>
      <div class="relative">
        <VIconButton
          icon="pi-times"
          class="!absolute -top-12 right-0"
          @click="close"
        />
        <div class="overflow-hidden rounded-2xl">
          <a
            :href="redirectUrl"
            target="_blank"
          >
            <img
              :src="imageUrl"
              alt="preview"
            >
          </a>
        </div>
      </div>
    </template>
  </VDialog>
</template>
